
import React, { useState } from 'react';
import { useAnimationFrame } from '../hooks/useAnimationFrame';
import { Json } from './Json';

interface LiveValueProps {
	callback: () => string;
}

export const LiveValue: React.FC<LiveValueProps> = ({ callback: callBack }) => {
	const [value, setValue] = useState(callBack());

	useAnimationFrame(() => {
		setValue(callBack());
	});

	if (typeof value === 'object' && value !== null) {
		return <Json value={JSON.stringify(value)} />;
	}
	return <>{value}</>;
};
